export const monitorAlertRead = (user, { organization, permissions }) => {
  return permissions.some((permission) => permission.resource === "monitor_alert" && permission.action === "read");
};
export const monitorAlertWrite = (user, { organization, permissions }) => {
  return permissions.some((permission) => permission.resource === "monitor_alert" && permission.action === "write");
};
